<template>
  <div class="summary-affix-container" :class="{sticky:sticky}">
    <span v-if="fixedTeam" class="team el-dropdown-link" style="height: 16px;">
      {{ currentTeam.label }}<i class="el-icon-arrow-down el-icon--right"/>
    </span>
    <el-dropdown v-else placement="bottom-end" @command="handleCommand">
      <span class="team el-dropdown-link">
        {{ currentTeam.label }}<i class="el-icon-arrow-down el-icon--right"/>
      </span>
      <el-dropdown-menu slot="dropdown" class="affix-team">
        <el-dropdown-item v-for="(team,index) in optionsTeam" :key="team.id" :command="team.id" :disabled="fixedTeam"
                          :divided="index===1||team.id==='NONE'">
          {{ team.label }}
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <div style="display: flex">
      <span class="last-script">
        更新时间：{{ lastScript.end_at || '--' }}
        <i class="el-icon-refresh-right" @click="runScript"/>
      </span>
      <month-select-group ref="date" @selected="changeMonth"/>
    </div>
  </div>
</template>

<script>
import {getLastRunDashBoardScript, runDashBoardScript} from "@/api/dashboard";
import {options} from "@/api/organization";
import {lsGet} from "@/utils";

const ModelDefaultTeam = {id: 'ALL', label: '全部'}
const ModelDefaultNoTeam = {id: 'NONE', label: '未分组'}

export default {
  name: "Affix",
  props: {
    sticky: {
      type: Boolean,
      default() {
        return false;
      }
    },
    organizationId: {
      type: [String, Number, Boolean],
      required: true
    }
  },
  data() {
    return {
      optionsTeam: [],
      currentTeam: ModelDefaultTeam,
      fixedTeam: true, // 固定小组不可选择
      lastScript: {start_at: '', end_at: ''},
    }
  },
  created() {
    this.init();
  },
  methods: {
    async init() {
      await this.getTeams();
      this.middleware()
    },
    middleware() {
      const {can_see_all_summary} = lsGet('userAuth')
      const {organization} = lsGet('user')
      const bool_leader = organization && organization.bool_leader
      if (!can_see_all_summary && bool_leader) {
        this.fixedTeam = true
        this.handleCommand(organization.organization_id)
      } else {
        this.fixedTeam = false
      }
    },
    handleCommand(command) {
      this.currentTeam = this.optionsTeam.find(_ => {
        return _.id == command
      })
      this.$emit("update:organizationId", this.currentTeam.id)
    },
    async getTeams() {
      const {model} = await options()
      this.optionsTeam = model || []
      this.optionsTeam.splice(0, 0, ModelDefaultTeam);
      this.optionsTeam.push(ModelDefaultNoTeam);
    },
    changeMonth(_) {
      this.$emit('selected', _)
      this.getLastRunScript()
    },
    runScript() {
      const {year, month} = this.$refs.date.searchCondition
      this.showToast({
        h: this,
        icon: 'el-icon-loading',
        text: year + '年' + month + '月报表数据更新中...'
      })
      runDashBoardScript(this.$refs.date.searchCondition).then(res => {
        if (res.model.run) {
          this.showToast({
            h: this,
            icon: 'el-icon-finished',
            text: '操作成功,请稍后刷新数据'
          });
          this.getLastRunScript()
        }
      });
    },
    getLastRunScript() {
      getLastRunDashBoardScript(this.$refs.date.searchCondition).then(res => {
        this.lastScript.start_at = res.model.script ? res.model.script.start_at : '--';
        this.lastScript.end_at = res.model.script ? res.model.script.end_at : '--';
      });
    },
  }
}
</script>

<style lang="scss">
.summary-affix-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  background-color: #fff;
  padding: 20px;

  &.sticky {
    width: calc(100% - 88px);
    padding: 10px 20px;
    position: fixed;
    top: 64px;
    background: #fff;
    z-index: 98;
    box-shadow: 0 2px 10px 0 rgba(201, 205, 214, .5);
  }

  .team {
    padding: 4px 15px;
    height: 24px;
    background-size: 100% 100%;
    background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAKwAAAAwCAYAAAH7kqF2AAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAArKADAAQAAAABAAAAMAAAAADj8lbIAAADmUlEQVR4Ae2dTZLTMBCFJRebKcgi7DgDB6BYTeAq/ByHA7DmGlAzO7gISwKVBAoWEXqaqHB1OWNb6jZ25XkxsTLWU+fzZ4+SeBLv4hK+7QJuVRb/YOPXV7deNfRUmX+88o1KlSIkbHcbk4oxjknFZihQcUSx/xy9eIaGxoJq9fl690I/ND5ckx22jNDTjtLd+xoGyQwUivtMBJCDabRtDgGNys5kmAh7ZqzquxdTLDRoXNO8rX7IxgH/DrAQvNvuj8bjFcfnQhHQzLlQFBi2v65xi2URp65MdxEHGKZxiyGbCrWa0CJcezGdJGsXi7xFOItC7/4oYG0hyyLILurUlXf87MlmqijYh5nPDTLVOd+2geY6Zz+PyYXO+bbrFajZH15zBtquTcIl2DadyvU2XIKthCm7Z7iLePoli19Cm8Za7CXvbglWG2yE6terDcFqgj1BRSTBaoFtQc1g91rZF5sjoCaw8enYynn/6WKh1D7wDqiITO/Whe+HN+54fBfbj2rHubT+Xa8TgEETtvuPEer7uE6oBVbkdw1kVz5BkEQK2l3WclZQAFJ26bKWxkpKhW1pLY0tBCm7SWtprCRU0W5bS2MrQMqubWtprKRT2c7W0thKkLJ7tpbGSjIKbVhLYxVAyghYS2MlFY02XpjJb35p5DHjjgBPBRYmRFsRS2OV4XK6pQw0xZ1sxTqNVQScbUUkp1taYFu2IpLGKoFt24pIGqsBVtiKSBqrAFbaikgaWwu2w1ZE+nA4PHG/j19r8y+1f5etCSx+JLh/wgcXwstLBcTH/Z8IxCMeFxEOHb1JF8HgTEBZhzLjdpoEgruOr7LeDI3EZGsXN+bFRUOJcTsbAgPPtJjEUlabXcDUMQQGnmn5rGsMVG5rS2CAtBTWdhcwfSyBHmkp7Fig3N6ewD3SUlh7/ByhhMAZaSlsCUz2mYZAh7QUdhr0HKWUgJCWwpaCZL/pCLSk5VUa02HnSLUE8OYCL4+vpcj+kxGIX3/AKcFktDlQFQF8V8d6dUNhqyiy8yQETrJiLAo7CXEOUkygJSsyKGwxSXY0JyBkxXgU1pw6Bygi0CErcihsEU12MiVwRlaMSWFNyTN8NIF7ZEUWhR1NlB3MCPTIinGjsP6LWQEMJoGhBNLXb69u+jZv3Prhc37MeR8m/t6UQDqzXqXPeeobJ318PDZKXzn34+drdwyvYutpvIv/69VHj7+vJ5DOrMNkxWB/AZmIJiNNCsibAAAAAElFTkSuQmCC);
    color: #fe346e;
  }


  .last-script {
    color: #9F9F9F;
    font-size: 10px;
    margin-right: 30px;
    //display: flex;
    //align-items: end;
    vertical-align: text-bottom;

    i {
      font-size: 14px;
      cursor: pointer;
    }
  }
}


.affix-team {
  .el-dropdown-menu__item {
    line-height: 28px;
  }
}
</style>